export default "__VITE_ASSET__I$k8a6u7__"